/**
 * API de Autenticação
 * Integração com backend/routes/auth_routes.py
 */
import apiService from '../core/apiService';
import { refreshWebSession } from '../core/webSessionRefresh';
// ============================================================================
// Auth API Service
// ============================================================================
/**
 * Serviço de API de autenticação
 * Métodos para login, registro, alteração de senha e gerenciamento de tokens
 */
const authApi = {
    /**
     * Realizar login
     * @param credentials - Credenciais de login
     * @returns Resposta com tokens e dados do usuário
     */
    async login(credentials) {
        try {
            await apiService.get('/api/auth/web/bootstrap');
            const response = await apiService.post('/api/auth/web', credentials);
            return response;
        }
        catch (error) {
            console.error('Erro no login:', error);
            throw error;
        }
    },
    /**
     * Registrar novo usuário
     * @param userData - Dados do usuário
     * @returns Resposta da criação do usuário
     */
    async register(userData) {
        try {
            const response = await apiService.post('/api/register', userData);
            return response;
        }
        catch (error) {
            console.error('Erro no registro:', error);
            throw error;
        }
    },
    /**
     * Alterar senha
     * @param passwordData - Dados da alteração de senha
     * @returns Resposta da alteração de senha
     */
    async changePassword(passwordData) {
        try {
            const response = await apiService.post('/api/alterar-senha', passwordData);
            return response;
        }
        catch (error) {
            console.error('Erro ao alterar senha:', error);
            throw error;
        }
    },
    /**
     * Renovar token JWT
     * @param refreshToken - Token de refresh
     * @returns Novo access token
     */
    async refreshToken(_refreshToken = '') {
        try {
            const response = await refreshWebSession();
            return (response ?? {
                status: 'erro',
                mensagem: 'Sessão Web ausente ou expirada',
            });
        }
        catch (error) {
            console.error('Erro ao renovar token:', error);
            throw error;
        }
    },
    /**
     * Obter dados do usuário atual
     * @returns Dados do usuário logado
     */
    async getCurrentUser() {
        try {
            const response = await apiService.get('/api/auth/me');
            return response;
        }
        catch (error) {
            console.error('Erro ao obter usuário atual:', error);
            throw error;
        }
    },
    /**
     * Realizar logout
     * @returns Resposta do logout
     */
    async logout() {
        try {
            const response = await apiService.post('/api/auth/web/logout');
            return response;
        }
        catch (error) {
            console.error('Erro no logout:', error);
            throw error;
        }
    },
};
export default authApi;
